import ProductionQualityInspectionDimensionDetail from '@/models/ProductionQualityInspectionDimension/ProductionQualityInspectionDimensionDetail';

export default class ProductionQualityInspectionDimensionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.productionQualityInspectionDimensionId  = '';
		this.productionQualityInspectionDimensionWorkOrderProcess = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.customer = '';
		this.isChecked = false;
		this.attachmentId  = '';
		this.attachmentOriginalFilename = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			productionQualityInspectionDimensionId : '0',
			productionQualityInspectionDimensionWorkOrderProcess : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			customer : '0',
			isChecked : '0',
			attachmentId : '0',
			attachmentOriginalFilename : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}